module.exports = "/img/videos/6.2b5fc0.mp4";